import { debounce } from 'lodash';
import { closest, removeClass, addClass, createEvent } from '@utils/domUtils';
import { get, post } from '@utils/request';

/* global jQuery, ACTION_ROUTES */

export default class JobBoostingSelectorBasket {
  static selectorString() {
    return '.JobBoostingSelectorBasket';
  }

  render(node, props) {
    this.jobId = props['job-id'];
    this.jobBoostChannelsForm = closest(this.node, '.wizard-form').querySelector(
      '.job-boost-channels-form',
    );
    this.jobBoostingSelector = closest(this.node, '.JobBoostingSelector');

    this.resize = debounce(this.resize.bind(this), 340);
    window.addEventListener('resize', this.resize);

    this.bindEvents();
  }

  bindEvents() {
    [...this.node.querySelectorAll('.remove-publish-channel')].forEach(element => {
      element.addEventListener('click', this.removePublishChannel.bind(this));
    });

    [...this.node.querySelectorAll('.remove-vonq-channel')].forEach(element => {
      element.addEventListener('click', this.removeVonqChannel.bind(this));
    });

    const submitBasketButton = this.node.querySelector('.submit-basket-button');

    if (submitBasketButton) {
      submitBasketButton.addEventListener('click', this.submitBasket.bind(this));
    }

    this.resize();
  }

  resize() {
    const height = this.node.offsetHeight + 100;

    if (height < window.innerHeight - 20) {
      addClass(this.node, 'position-sticky');
      addClass(this.node, 'top-100px');
    } else {
      removeClass(this.node, 'position-sticky');
      removeClass(this.node, 'top-100px');
    }
  }

  submitBasket(event) {
    event.preventDefault();

    this.jobBoostChannelsForm.dispatchEvent(createEvent('submit'));
  }

  removePublishChannel(event) {
    event.preventDefault();

    const element = event.currentTarget;

    if (element.getAttribute('data-locked') === 'true') {
      return false;
    }

    element.setAttribute('data-locked', 'true');

    const channelId = element.getAttribute('data-id');

    if (channelId && !isNaN(this.jobId)) {
      post({
        url: ACTION_ROUTES.REMOVE_CHANNEL_FROM_BASKET,
        data: {
          jobId: this.jobId,
          channelId: channelId,
        },
        success: data => {
          element.removeAttribute('data-locked');
          this.updateBasket(data);
        },
        error: () => element.removeAttribute('data-locked'),
      });
    }
  }

  removeVonqChannel(event) {
    event.preventDefault();

    const element = event.currentTarget;

    if (element.getAttribute('data-locked') === 'true') {
      return false;
    }

    element.setAttribute('data-locked', 'true');

    const channelId = element.getAttribute('data-id');

    if (channelId && !isNaN(this.jobId)) {
      post({
        url: ACTION_ROUTES.REMOVE_VONQ_CHANNEL_FROM_BASKET,
        data: {
          jobId: this.jobId,
          channelId: channelId,
        },
        success: data => {
          element.removeAttribute('data-locked');
          this.updateBasket(data);
        },
        error: () => {
          element.removeAttribute('data-locked');
        },
      });
    }
  }

  updateBasket(data) {
    if (data && data.responseText) {
      this.renderUpdatedBasket(data.responseText);
    } else {
      get({
        url: window.location.href.toString(),
        success: result => {
          this.renderUpdatedBasket(result.responseText);
        },
      });
    }
  }

  renderUpdatedBasket(html) {
    const $html = jQuery(html);

    jQuery('.selected-job-boosting-channels').html(
      $html.find('.selected-job-boosting-channels').html(),
    );

    const newBasket = $html.find('.JobBoostingSelectorBasket').get(0);
    const newBasketData = newBasket.getAttribute('data-basket');

    this.node.innerHTML = newBasket.innerHTML;
    this.node.setAttribute('data-basket', newBasketData);
    this.props.basket = JSON.parse(newBasketData);

    [...this.jobBoostingSelector.querySelectorAll('.JobBoostingChannelCard')].forEach(element => {
      removeClass(element, 'selected');
    });

    [...this.props.basket.publishChannels, ...this.props.basket.vonqChannels].forEach(channelId => {
      const channel = this.jobBoostingSelector.querySelector(
        `.JobBoostingChannelCard[data-id="${channelId}"]`,
      );

      if (channel) {
        addClass(channel, 'selected');
      }
    });

    jQuery('[name="_basket"]').val($html.find('[name="_basket"]').val());
    jQuery('[name="_basket"]').get(0).dispatchEvent(createEvent('validate'));

    this.bindEvents();
  }
}
